// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1jHHO","footer":"ModalError_footer__6XcdD"};